const o = (t) => ({
  heading: {
    color: t.palette.common.blue400,
    fontSize: t.typography.fontSize32,
    lineHeight: 1.6
  },
  avatarImg: {
    minHeight: 550,
    "& > img": {
      borderRadius: 24,
      width: "100%",
      minHeight: "inherit",
      objectFit: "cover"
    },
    "@media(max-width: 600px)": {
      minHeight: "auto",
      marginBottom: 40
    }
  },
  content: {
    marginBottom: 24,
    "@media(max-width: 600px)": {
      marginBottom: 0
    }
  },
  title: {
    color: t.palette.common.gray400,
    fontSize: t.typography.fontSize20,
    fontWeight: t.typography.fontWeightBold
  },
  subTitle: {
    color: t.palette.common.gray400,
    fontSize: t.typography.fontSize18,
    fontStyle: "italic"
  },
  text: {
    color: t.palette.common.gray400,
    fontSize: t.typography.fontSize16,
    marginBottom: 32
  }
}), i = o;
export {
  i as default
};
